module.exports = "* {\n  box-sizing: border-box;\n}\n\nhtml {\n  background-color: black;\n  color: #eee;\n}\n"